import { ApolloProvider } from '@apollo/client';
import type { AppProps } from 'next/app';

import '@thinkific/chalk/stylesheet.css';
import { ToastContainer } from '@thinkific/toga-react';

import ErrorBoundary from '@/components/ErrorBoundary';
import FullStoryInitializer from '@/components/FullStoryInitializer';
import { AnalyticsProvider } from '@/hooks/useAnalytics';
import { apolloClient } from '@/lib/apolloClient';
import '@/styles/styles.scss';

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <ApolloProvider client={apolloClient}>
        <FullStoryInitializer>
          <AnalyticsProvider>
            <ToastContainer />
            <Component {...pageProps} />
          </AnalyticsProvider>
        </FullStoryInitializer>
      </ApolloProvider>
    </ErrorBoundary>
  );
}

export default MyApp;
